import { UserType } from 'shared-general-libs/type/user';

/**
 * The six portal path prefixes declared in `app.routes.ts`, each guarded by
 * `[authGuard, <portal>Guard]`. Every other declared path (`''`, `not-found`,
 * `materiality-survey-answer/:type/:formId`, `force-password-reset`,
 * `permission-denied`, `**`) is deliberately absent: none of them is a landing
 * target a login redirect may be pointed at.
 */
export const PORTAL_PREFIXES = [
  'admin',
  'partner',
  'portfolio',
  'auditor',
  'certifier',
  'enterprise',
] as const;

export type PortalPrefix = (typeof PORTAL_PREFIXES)[number];

/**
 * The one portal each user type may land in — mirrors the user-type test the
 * matching `core/guards/<portal>.guard.ts` already performs. Keyed by the same
 * `UserType` set as `NAV_MENU`.
 */
export const PORTAL_FOR_USER_TYPE: Record<UserType, PortalPrefix> = {
  [UserType.SUPER_ADMIN]: 'admin',
  [UserType.ENTERPRISE_USER]: 'enterprise',
  [UserType.ENTERPRISE_ADMIN]: 'enterprise',
  [UserType.PARTNER_USER]: 'partner',
  [UserType.PORTFOLIO_USER]: 'portfolio',
  [UserType.CERTIFIER_USER]: 'certifier',
  [UserType.AUDITOR_USER]: 'auditor',
};
